<template>
  <div>
    <a-card
      size="small"
      title="查询"
      :headStyle="{
        background: '#f3f3f3',
      }"
    >
      <a-form layout="inline">
        <a-form-item>
          <a-input
            placeholder="手机"
            v-model:value="searchForm.mobile"
            allowClear
            @keyup.enter.native="searchAction()"
          />
        </a-form-item>

        <a-form-item>
          <a-select
            v-model:value="searchForm.state"
            placeholder="商户类型"
            mode="tag"
            style="width: 192px"
            @change="searchAction"
          >
            <a-select-option
              v-for="(item, index) in stateList"
              :key="index"
              :value="item.val"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item>
          <df-selectChannelShop
            :model="searchForm"
            @setValue="searchAction"
          ></df-selectChannelShop>
        </a-form-item>

        <a-form-item>
          <a-button type="primary" @click="searchAction"> 查询 </a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="reset">重置</a-button>
        </a-form-item>
        <a-form-item> </a-form-item>
      </a-form>
    </a-card>

    <a-card
      size="small"
      title="账户列表"
      style="margin-top: 20px"
      :headStyle="{
        background: '#f3f3f3',
      }"
      :bodyStyle="{
        padding: '0',
      }"
    >
      <template v-slot:extra>
        <a-button @click="toAdd" type="primary">添加</a-button>
      </template>

      <a-table
        :columns="columns"
        bordered
        :data-source="list"
        :pagination="false"
        :row-key="(r) => r.id"
        :loading="loading"
      >
        <template v-slot:distributorName="{ text, record }">
          <span
            style="color: #464c5b; cursor: pointer"
            @click="toShopDetail(record)"
            >{{ record.distributorName }}</span
          >
        </template>

        <template v-slot:switch="{ text, record, index }">
          <a-switch
            :defaultChecked="record.state ? true : false"
            @change="onChange(record, index)"
          />
        </template>

        <template v-slot:state="{ text, record }">
          {{ record.state ? "开启" : "关闭" }}
        </template>

        <template v-slot:apiButton="{ text, record }">
          <a-button type="primary" @click="apiInfoEdit(record)"> 接口信息 </a-button>
        </template>

        <template v-slot:button="{ text, record }">
          <a-button type="primary" @click="edit(record)"> 编辑 </a-button>
        </template>
      </a-table>
    </a-card>

    <df-pagination :model="pageObj"></df-pagination>

    <a-modal v-model:visible="modalVisible" :title="accountTitle" @ok="handleOk">
      <!-- @ok="handleOk" -->
      <a-form
        layout="horizontal"
        :ref="setsubmitForm"
        :model="submitForm"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item label="渠道名称" name="distributorId" class="required">
          <df-selectChannelShop
            :model="submitForm"
            @setValue="setValue"
            :disabled="isedit"
          ></df-selectChannelShop>
        </a-form-item>
        <a-form-item label="账号名称" name="displayName">
          <a-input
            v-model:value="submitForm.displayName"
            placeholder="账号名称"
            style="width: 282px"
          />
        </a-form-item>

        <a-form-item label="登陆账号" name="account">
          <a-input
            v-model:value="submitForm.account"
            placeholder="登陆账号"
            style="width: 282px"
            :disabled="isedit"
          />
        </a-form-item>

        <a-form-item label="登陆密码" name="password" v-if="!isedit">
          <a-input
            v-model:value="submitForm.password"
            placeholder="登陆密码"
            style="width: 282px"
          />
        </a-form-item>

        <a-form-item label="手机号码" name="mobile">
          <a-input
            v-model:value="submitForm.mobile"
            placeholder="手机号码"
            style="width: 282px"
          />
        </a-form-item>

        <a-form-item label="业务类型" name="business">
          <a-checkbox-group
            style="margin-left: 10px"
            v-model:value="submitForm.business"
            :disabled="submitForm.main == 'Y'"
          >
            <a-checkbox
              v-for="(item, index) in businessList"
              :key="index"
              :value="item"
            >
              {{ settlementsKeys[item] }}
            </a-checkbox>
          </a-checkbox-group>
        </a-form-item>

        <a-form-item label="是否主要" name="main">
          <a-radio-group v-model:value="submitForm.main" button-style="solid">
            <a-radio-button value="Y"> 是 </a-radio-button>
            <a-radio-button value="N"> 否 </a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal v-model:visible="isShowApiInfo" title="接口信息" @ok="handleApiInfo">
      <!-- @ok="handleOk" -->
      <a-form
          layout="horizontal"
          :ref="setsubmitForm"
          :model="apiSignForm"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
      >
        <a-form-item label="APPID" name="displayName">
          <a-input
              v-model:value="apiSignForm.id"
              placeholder="APPID"
              disabled="true"
              style="width: 320px"
          />
        </a-form-item>

        <a-form-item label="signKey" name="displayName">
          <a-input
              v-model:value="apiSignForm.signKey"
              placeholder="signKey"
              disabled="true"
              style="width: 320px"
          />
        </a-form-item>


      </a-form>
    </a-modal>
  </div>
</template>

<script>
import shopApi from "@axios/shop";
import staticof from "@assets/static";
import { ref, reactive, provide } from "vue";
import { useRoute, useRouter } from "vue-router";
import { message, notification } from "ant-design-vue";
import { SmileOutlined } from "@ant-design/icons-vue";
import moment from "moment";
import { get } from "http";
import async from "async";

export default {
  name: "order",
  components: {},
  setup() {
    let checkDistributorId = (rule, value, callback) => {
      if (!value) {
        return Promise.reject("请选择渠道商户");
      } else {
        return Promise.resolve();
      }
    };
    let submitFormref = "";
    const setsubmitForm = (el) => {
      submitFormref = el;
    };

    var checkPhone = async (rule, value) => {
      if (!value) {
        return Promise.reject("手机号不能为空");
      } else {
        const reg = /^1[3|4|5|6|7|8][0-9]\d{8}$/;
        if (reg.test(value)) {
          Promise.resolve();
        } else {
          return Promise.reject("请输入正确的手机号");
        }
      }
    };
    const router = useRouter();
    const route = useRoute();
    const modalVisible = ref(false);
    let submitForm = reactive({
      distributorId: "",
      displayName: "",
      account: "",
      password: "",
      mobile: "",
      main: "N",
      business: [],
    });
    let accountTitle = ref("添加账号");

    const  isShowApiInfo = ref(false);

    let apiSignForm = reactive({
      id:"",
      distributorId: "",
      accountId:"",
      signKey:"",
      state:'',
    });

    const rules = {
      distributorId: [{ validator: checkDistributorId, trigger: "blur" }],
      displayName: [
        { required: true, message: "请输入显示名称", trigger: "blur" },
      ],
      account: [{ required: true, message: "请输入账户", trigger: "blur" }],
      password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      mobile: [
        { required: true, message: "请输入电话号码", trigger: "blur" },
        { validator: checkPhone, trigger: "blur" },
      ],
      main: [
        { required: true, message: "请选择是否是主账号", trigger: "change" },
      ],
    };
    let loading = ref(false);
    let searchForm = ref({
      mobile: "",
      state: 999,
      distributorId: "",
    });
    let searchParams = ref({
      mobile: "",
      state: 999,
      distributorId: "",
    });

    let names = ref("");

    let list = ref([]);

    const columns = [
      {
        title: "渠道商",
        dataIndex: "distributorName",
        width: 100,
        align: "center",
        slots: { customRender: "distributorName" },
      },

      {
        title: "账户",
        dataIndex: "account",
        width: 200,
        align: "center",
      },
      {
        title: "主要",
        dataIndex: "mainValue",
        width: 50,
        align: "center",
      },
      {
        title: "手机号",
        dataIndex: "mobile",
        width: 200,
        align: "center",
      },
      {
        title: "状态",
        dataIndex: "state",
        width: 100,
        align: "center",
        slots: { customRender: "state" },
      },
      {
        title: "开通业务",
        dataIndex: "businessModulesValue",
        width: 150,
        align: "center",
      },
      {
        title: "创建时间",
        dataIndex: "createTime",
        width: 150,
        align: "center",
      },
      {
        title: "开关",
        dataIndex: "lastLoginTime",
        width: 100,
        align: "center",
        slots: { customRender: "switch" },
      },
      {
        title: "查看接口",
        dataIndex: "apiInfo",
        width: 100,
        align: "center",
        slots: { customRender: "apiButton" },
      },
      {
        title: "操作",
        dataIndex: "lastLoginTime",
        width: 100,
        align: "center",
        slots: { customRender: "button" },
      },
    ];

    let pageObj = ref({
      page: 1,
      rows: 10,
      totle: 1,
    });

    const stateValue = ["关闭", "开启"];

    const searchAction = () => {
      searchParams.value.state = searchForm.value.state;
      searchParams.value.mobile = searchForm.value.mobile;
      searchParams.value.distributorId = searchForm.value.distributorId;

      console.log(searchParams);
      pageObj.value = {
        page: 1,
        rows: 10,
        totle: 1,
      };
      getList();
    };

    const getList = () => {
      loading.value = true;
      let params = {
        distributorId: searchParams.value.distributorId
          ? searchParams.value.distributorId
          : null,
        mobile: searchParams.value.mobile ? searchParams.value.mobile : null,
        currentPage: pageObj.value.page,
        size: pageObj.value.rows,
      };

      if (searchParams.value.state === 10) {
        params.state = 1;
      } else if (searchParams.value.state === 20) {
        params.state = 0;
      }

      shopApi.geDistributorAccountList(params).then((res) => {
        loading.value = false;
        if (!res) return;
        pageObj.value.totle = res.total;
        pageObj.value.page = res.page;

        list.value = res.data;
      });
    };

    const reset = () => {
      searchForm.value.state = 999;
      searchForm.value.mobile = "";
      searchForm.value.distributorId = "";
      searchAction();
    };
    const toLook = (row) => {
      router.push({
        name: "addShopIndex",
        query: {
          id: row.id,
          type: "look",
        },
      });
    };

    const toAdd = () => {
      submitForm.distributorId = "";
      submitForm.account = "";
      submitForm.displayName = "";
      submitForm.password = "";
      submitForm.mobile = "";
      submitForm.main = "N";
      submitForm.business = [];
      modalVisible.value = true;
      isedit.value = false;
      accountTitle.value = "添加账号"
    };
    const toEdit = (row) => {
      router.push({
        name: "addShopIndex",
        query: {
          id: row.id,
          type: "edit",
        },
      });
    };
    const pageChange = (page) => {
      pageObj.value.page = page;
      getList();
    };

    const onShowSizeChange = (current, pageSize) => {
      pageObj.value.page = 1;
      pageObj.value.rows = pageSize;
      getList();
    };

    const changeBtn = (row) => {
      let params = {
        lid: row.id,
        type: row.state == 1 ? 0 : 1,
      };
      shopApi.switchSupplier(params).then(() => {
        searchAction();

        notification.open({
          message: "修改成功",
          icon: <SmileOutlined style="color: #108ee9" />,
        });
      });
    };

    const handleOk = () => {
      submitFormref
        .validate()
        .then(() => {
          if (!submitForm.business.length) {
            message.error("请选择业务类型");
            return;
          }
          //添加账号
          if (isedit.value) {
            let params = {
              id: editid,
              displayName: submitForm.displayName,
              main: submitForm.main,
              mobile: submitForm.mobile,
              businessModules: submitForm.business.join(","),
            };
            shopApi.updateDistributorAccount(params).then((res) => {
              modalVisible.value = false;
              getList();
              notification.open({
                message: "编辑成功",
                icon: <SmileOutlined style="color: #108ee9" />,
              });
            });
          } else {
            let params = {
              distributorId: submitForm.distributorId,
              displayName: submitForm.displayName,
              account: submitForm.account,
              password: submitForm.password,
              main: submitForm.main,
              mobile: submitForm.mobile,
              businessModules: submitForm.business.join(","),
            };
            shopApi.addDistributorAccount(params).then((res) => {
              modalVisible.value = false;
              getList();
              notification.open({
                message: "添加成功",
                icon: <SmileOutlined style="color: #108ee9" />,
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const handleApiInfo = () => {
      isShowApiInfo.value = false
    }

    let isedit = ref(false);
    let editid = "";
    const edit = (row) => {
      accountTitle.value = "编辑账号"
      editid = row.id;
      isedit.value = true;
      modalVisible.value = true;
      submitForm.distributorId = row.distributorId;
      submitForm.displayName = row.displayName;
      submitForm.account = row.account;
      submitForm.password = row.password;
      submitForm.mobile = row.mobile;
      submitForm.business = row.businessModules.split(",");
      submitForm.main = row.main
      setBusinessList(row.distributorId);
    };
     const  apiInfoEdit = async (row) => {

       if (row.main !== "Y"){
         message.info("当前非主账户，无接口信息");
         return;
       }
      var param = {
        distributorId: row.distributorId,
        accountId: row.accountId,
      }

      await shopApi.apiInfoApp(param).then((res) => {
        apiSignForm.signKey = res.signKey
        apiSignForm.id = res.id

      });

      isShowApiInfo.value = true

    };

    const setBusinessList = (id) => {
      shopApi.getDistributor(id).then((res) => {
        businessList.value = res.businessModules.split(",");
      });
    };

    const onChange = (row, index) => {
      let params = {
        lid: row.id,
        type: row.state == 1 ? 0 : 1,
      };
      shopApi
        .updateDistributorState(params)
        .then(() => {
          notification.open({
            message: "修改成功",
            icon: <SmileOutlined style="color: #108ee9" />,
          });
          getList();
        })
        .catch(() => {
          notification.open({
            message: "修改失败",
            icon: <SmileOutlined style="color: #108ee9" />,
          });
          getList();
        });
    };

    provide("pageChange", pageChange);
    provide("onShowSizeChange", onShowSizeChange);

    const stateList = [
      {
        name: "全部",
        val: 999,
      },
      {
        name: "开启",
        val: 10,
      },
      {
        name: "关闭",
        val: 20,
      },
    ];

    let businessList = ref([]);

    const setValue = (val) => {
      submitForm.business = undefined;
      businessList.value = val.business.split(",");
    };

    const toShopDetail = (record) => {
      const newweb = router.resolve({
        name: "addChannelShopIndex",
        query: {
          id: record.distributorId,
          type: "look",
        },
      });
      window.open(newweb.href, "_blank");
    };

    if (route.query.distributorId) {
      searchForm.value.distributorId = parseInt(route.query.distributorId);
      searchParams.value.distributorId = parseInt(route.query.distributorId);
    }

    getList();

    return {
      toShopDetail,
      businessList,
      setValue,
      stateList,
      onChange,
      isedit,
      edit,
      apiInfoEdit,
      names,
      // data
      staticof,
      loading,
      searchForm,
      searchParams,
      list,
      columns,
      pageObj,
      stateValue,
      //methods
      searchAction,
      reset,
      toLook,
      toAdd,
      toEdit,
      modalVisible,
      moment,
      disabledDate(current) {
        // Can not select days before today and today

        return current && current < moment().endOf("day");
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      rules,
      submitForm,
      handleOk,
      handleApiInfo,
      setsubmitForm,
      settlementsKeys: {
        10: "火车票",
        20: "酒店",
        30: "国内机票",
        40: "国际机票",
        50: "打车",
      },
      isShowApiInfo,
      apiSignForm,
      accountTitle,
    };
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.table_logo {
  width: 70px;
}
</style>



